module.exports = __webpack_public_path__ + "img/fas-volume-slash.20bea358.svg";